<template>
  <div id="app">
    <!-- 切路由 -->
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: "App",
  data() {
    return {}
  },
}
</script>

<style>
*,
body {
  margin: 0;
  padding: 0;
  -webkit-tap-highlight-color: transparent;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: relative;
  overflow: hidden;
  user-select: none;
  width: 100vw;
  height: 100vh;
}
</style>
